import { Backdrop, CircularProgress } from '@mui/material';

export const BackkdropLoader = () => {
	return (
		<Backdrop
			sx={{
				color: 'white',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				flexDirection: 'column',
				zIndex: theme => theme.zIndex.drawer + 1
			}}
			open>
			<CircularProgress color='inherit' />
		</Backdrop>
	);
};
